import * as Mortgage from '@/src/experiences/mortgage'
import { useSourcePartnerName } from '@/src/common/hooks/useSourcePartnerName'
import { MesaSection } from './MesaSection'
import { PartnerSection } from './PartnerSection'

export function MortgageSection() {
  const { sourcePartnerName } = useSourcePartnerName()
  const moduleDesign = Mortgage.Statsig.Store.useMortgageModuleDesign(sourcePartnerName)

  if (moduleDesign.partner_code === 'default') {
    return <MesaSection />
  }

  return <PartnerSection partnerCode={moduleDesign.partner_code} />
}
